import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './style.css';
import { Panel, Div, Button, Link, Icon } from '../../components';
import chery from '../../img/chery.svg';
import sqad from '../../img/sqad.svg';
import sqad2 from '../../img/sqad.svg';
import portal from '../../img/portal.svg';
import portal2 from '../../img/portal2.svg';
import { Game } from '../../logic/game';
import { addStr, weiToEth } from '../../logic/utils';
export const Boards = (props) => {
    const [firstRender, setFirstRender] = React.useState(false);
    const [firstRender2, setFirstRender2] = React.useState(false);
    const [firstRender3, setFirstRender3] = React.useState(false);
    const [listGames, setListGames] = React.useState(undefined);
    const [game, setGame] = React.useState(undefined);
    const [infoGames, setInfoGames] = React.useState(undefined);
    const [infoGamesDay, setInfoGamesDay] = React.useState(undefined);
    const history = useNavigate();
    async function getInfo(list = listGames, gameLocal = game) {
        if (!gameLocal || !list) {
            console.error('getInfo game list');
            return undefined;
        }
        const info = await gameLocal.getAllInfoGames(list);
        if (!info)
            return undefined;
        setInfoGames(info);
        return true;
    }
    async function getBoardDay(gameLocal = game) {
        if (!gameLocal) {
            console.error('getBoardDay game');
            return undefined;
        }
        const address = await gameLocal.getGameDay();
        if (!address) {
            console.error('getBoardDay address');
            return undefined;
        }
        const info = await gameLocal.getAllInfoGames([address]);
        if (!info) {
            console.error('getBoardDay info');
            return undefined;
        }
        setInfoGamesDay(info[0]);
        return true;
    }
    async function loadDataPage(accaount, wallet) {
        console.log('getData', accaount);
        if (accaount) {
            const gameLocal = new Game({
                address: '',
                addressUser: '',
                wallet,
                network: props.typeNetwork
            });
            setGame(gameLocal);
            gameLocal.getAllGames().then((games) => {
                if (games) {
                    getInfo(games, gameLocal);
                    setListGames(games);
                }
            });
            getBoardDay(gameLocal);
            // console.log('compl', gameLocal)
        }
        else {
            setListGames(undefined);
            setInfoGamesDay(undefined);
            setInfoGames(undefined);
            setGame(undefined);
            setGame(undefined);
        }
    }
    useEffect(() => {
        // if (!firstRender &&
        //      props.venomWallet?.provider && props.venomWallet?.account) {
        //     setFirstRender(true)
        //     setGame(new Game({
        //         address: '',
        //         addressUser: '',
        //         wallet: props.venomWallet,
        //         network: props.typeNetwork
        //     }))
        // }
        // if (firstRender && !props.venomWallet?.account) {
        //     setFirstRender3(false)
        // }
    }, [props.venomWallet?.account]);
    useEffect(() => {
        // if (game && !firstRender2  && props.venomWallet?.account) {
        //     setFirstRender2(true)
        //     // console.log('=======')
        //     game.getAllGames().then((games) => {
        //         if (games) setListGames(games)
        //     })
        // }
        // if (firstRender2 && !props.venomWallet?.account) {
        //     setFirstRender3(false)
        //     setListGames([])
        // }
    }, [game, props.venomWallet?.account]);
    useEffect(() => {
        // if (props.venomWallet) loadDataPage(!!props.venomWallet?.account, props.venomWallet)
        // if (listGames && game && !firstRender3 && props.venomWallet?.account) {
        //     setFirstRender3(true)
        //     // console.log('=======')
        //     getInfo()
        //     getBoardDay()
        // }
        // if (firstRender3 && !props.venomWallet?.account) {
        //     setFirstRender3(false)
        //     setInfoGamesDay(undefined)
        // }
    }, [listGames, props.venomWallet?.account]);
    useEffect(() => {
        if (props.venomWallet?.address) {
            console.log('Test address', props.venomWallet?.address);
            loadDataPage(true, props.venomWallet);
        }
        else if (!props.venomWallet?.address) {
            console.log('no address');
            loadDataPage(false, props.venomWallet);
        }
    }, [props.venomWallet?.address && props.venomWallet?.account]);
    return (_jsx(Panel, { id: props.id, children: _jsxs(Div, { className: "panel-boards", children: [_jsxs("div", { className: "nav-bar", children: [_jsx(Link, { onClick: () => history('/'), children: "Home" }), _jsx("img", { src: chery }), _jsx("div", { children: "Boards" })] }), _jsxs("div", { className: "page-block", style: props.isMobile ? { flexDirection: 'column' } : {}, children: [!props.isMobile
                            && infoGamesDay && infoGamesDay.rounds && infoGamesDay.rounds?._rounds.length > 0 ? _jsxs("div", { className: "left-menu", children: [_jsxs("div", { className: "title-bar", children: [_jsx("h3", { className: 'raider-font', children: "Board of the Day" }), _jsx("div", { className: "right-bar" })] }), _jsxs("div", { className: "group-block", style: { padding: 0 }, children: [_jsxs("div", { className: "header-block", children: [_jsxs("div", { className: "map-block", children: [_jsxs("div", { style: { padding: '0 0 20px 0', width: '100%' }, children: [_jsx("h4", { children: "Fiercy Trickster" }), _jsx("div", { className: "blue-text", children: "Hard" })] }), _jsx("div", { className: "hr" }), _jsxs("div", { style: { width: '100%' }, children: [_jsxs("div", { className: "map-block-cell", children: [_jsx(Icon, { src: sqad, size: 16 }), _jsxs("span", { children: [infoGamesDay.info?._board.columns, " x ", infoGamesDay.info?._board.columns, " cells"] }), _jsxs("div", { className: "map-block-cell-right", children: [_jsx(Icon, { src: portal, size: 24 }), _jsx("span", { children: infoGamesDay.info?._redBeams.length })] })] }), _jsxs("div", { className: "map-block-cell", children: [_jsx(Icon, { src: sqad2, size: 16 }), _jsxs("span", { children: [infoGamesDay.rounds?._rounds[0].maxPlayers, " players"] }), _jsxs("div", { className: "map-block-cell-right color-blue", children: [_jsx(Icon, { src: portal2, size: 24 }), _jsx("span", { children: infoGamesDay.info?._blueBeams.length })] })] })] })] }), _jsxs("div", { className: "info-block", children: [_jsxs("div", { children: [_jsxs("h3", { children: [weiToEth(infoGamesDay.jackpot, 9), _jsx("span", { children: props.nameNetwork.toUpperCase() })] }), _jsx("div", { className: "blue-text", children: "remaining prize fund" })] }), _jsxs("div", { children: [_jsxs("h4", { children: [weiToEth(infoGamesDay.rounds?._rounds[0].prizeFund, 9), _jsx("span", { children: props.nameNetwork.toUpperCase() })] }), _jsx("div", { className: "blue-text", children: "prize per round" })] }), _jsx(Button, { onClick: () => history('/boards/' + infoGamesDay.address.toString()), children: "Play now!" })] })] }), _jsx("div", { className: "info-of-game", style: { padding: '20px' }, children: _jsx("div", { className: "in-block" }) })] })] }) : null, _jsxs("div", { className: "content-block", style: props.isMobile ? { width: '100%' }
                                : { width: infoGamesDay && infoGamesDay.rounds ? '60%' : '100%', marginLeft: '30px' }, children: [_jsxs("div", { className: "title-bar", children: [_jsx("h3", { className: 'raider-font', children: "All boards" }), _jsx("div", { className: "right-bar" })] }), _jsx("div", { className: "group-block", children: _jsx(Div, { children: _jsxs("table", { className: "table-block", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Address" }), _jsx("th", { children: "Size" }), _jsx("th", { children: "Portals" }), _jsx("th", { children: "Rounds" }), _jsxs("th", { children: ["Prize per", _jsx("br", {}), " round, ", props.nameNetwork.toUpperCase()] }), _jsxs("th", { children: ["Balance left,", _jsx("br", {}), " ", props.nameNetwork.toUpperCase()] })] }) }), _jsx("tbody", { children: infoGames && infoGames.map((gameL, key) => (gameL && gameL.info && gameL.rounds ? _jsxs("tr", { children: [_jsx("td", { onClick: () => history('/boards/' + gameL.address.toString()), children: addStr(gameL.address.toString()) }), _jsx("td", { children: gameL.info._board.columns + 'x' + gameL.info._board.columns }), _jsxs("td", { children: ["\uD83D\uDD35 ", gameL.info._blueBeams.length, " \uD83D\uDD34 ", gameL.info._redBeams.length] }), _jsx("td", { children: gameL.rounds._rounds.length }), _jsx("td", { children: weiToEth(gameL.rounds._rounds[0]?.prizeFund, 9) }), _jsx("td", { children: weiToEth(gameL.rounds._rounds[0]?.prizeFund, 9) })] }, key) : null)) })] }) }) })] })] })] }) }));
};
